/* 🤖 this file was generated by svg-to-ts */
export const matIconEast: {
  name: 'east';
  data: string;
} = {
  name: 'east',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m15 5-1.41 1.41L18.17 11H2v2h16.17l-4.59 4.59L15 19l7-7-7-7z"/></svg>`
};
